import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Authorization from 'components/global/Authorization';
import Typography from 'components/global/Typography';

import useAccessControl from 'hooks/useAccessControl';
import useModalRouter from 'hooks/useModalRouter';

import PATHS, { mergePaths } from 'utils/paths';

import { faCalculator, faLink, faPlus } from '@fortawesome/pro-solid-svg-icons';

import * as S from './HomeCards.styled';

const HomeCards = () => {
	const isAuthorized = useAccessControl();
	const user = useSelector((state) => state.user);
	const { showModal } = useModalRouter();

	const navigate = useNavigate();
	const isEnterprise = user?.planName === 'EnterprisePackage';

	return (
		<Authorization path="/home/quickActions">
			<S.CardsContainer>
				<S.HomeCardContainer>
					<HomeCard
						type="createShipment"
						title={isEnterprise ? 'addOrder' : 'createShipment'}
						backgroundColor="var(--blue-10)"
						icon={faPlus}
						iconButtonColor="var(--blue)"
						image="https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/cta/create-shipment.png"
						linearColors={['#5a77ff', '#3d5fff']}
						iconButtonHoverColor="var(--blue-60)"
						onClick={() => {
							isAuthorized(PATHS.CREATE_SHIPMENT);
							if (isEnterprise) {
								showModal('add-order-form');
							} else {
								navigate(PATHS.CREATE_SHIPMENT);
							}
						}}
					/>
					<HomeCard
						type="salesChannel"
						title="connectToYourSalesChannel"
						backgroundColor="var(--forest-10)"
						icon={faLink}
						iconButtonColor="var(--forest)"
						image="https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/cta/connect-to-sales-channel.png"
						linearColors={['#26cb95', '#0b9669']}
						iconButtonHoverColor="var(--forest-60)"
						onClick={() => {
							navigate(mergePaths(PATHS.SALES_CHANNELS, PATHS.ONLINE_STORES));
						}}
					/>
					<HomeCard
						type="shippingRates"
						title="shippingRatesAndOffers"
						backgroundColor="var(--yellow-10)"
						icon={faCalculator}
						iconButtonColor="var(--yellow)"
						image="https://storage.googleapis.com/tryoto-public/public/assets/images/homepage/cta/shipping-rates-and-offers.png"
						linearColors={['#FFD15B', '#E3A80D']}
						iconButtonHoverColor="var(--yellow-60)"
						onClick={() => {
							navigate(PATHS.PRICE_CALCULATOR);
						}}
					/>
				</S.HomeCardContainer>
			</S.CardsContainer>
		</Authorization>
	);
};

const HomeCard = ({
	type,
	title,
	backgroundColor,
	icon,
	iconButtonColor,
	onClick,
	image,
	linearColors,
	iconButtonHoverColor
}) => {
	return (
		<S.HomeCard
			type={type}
			backgroundColor={backgroundColor}
			onClick={onClick}
			linearColors={linearColors}
			iconButtonHoverColor={iconButtonHoverColor}>
			<S.HomeCardContent>
				<Button
					iconButton={true}
					color={iconButtonColor}
					icon={icon}
					iconSize="large"
					className="home-card-button-icon"
				/>
				<Typography variant="p1" fontWeight="700" noWrap className="home-card-title">
					{title}
				</Typography>
			</S.HomeCardContent>
			{image && <S.CardBackImage src={image} alt="Card Background" className="card-image" />}
		</S.HomeCard>
	);
};

export default HomeCards;
